import classNames from 'classnames';

import { ProgrammeDetail, SupabaseEventRecord } from '@interfaces';

import styles from './listing-detail-top-section.module.scss';
import { ListingDetailArtwork } from './ListingDetailArtwork';
import { ListingDetailHeader } from './ListingDetailHeader';
import { ListingDetailPrimaryInformation } from './ListingDetailPrimaryInformation';

interface ListingDetailTopSectionProps {
	className?: string;
	event: SupabaseEventRecord;
	programmeData: ProgrammeDetail;
}

export const ListingDetailTopSection = ({
	className,
	event,
	programmeData,
}: ListingDetailTopSectionProps) => {
	return (
		<section
			className={classNames(className, styles['listing-detail-top-section'])}
		>
			<ListingDetailHeader
				className={styles['listing-detail-top-section__header']}
				event={event}
				programmeData={programmeData}
			/>
			<ListingDetailArtwork
				className={styles['listing-detail-top-section__artwork']}
				event={event}
			/>
			<ListingDetailPrimaryInformation
				className={styles['listing-detail-top-section__information']}
				event={event}
				infoBlocks={programmeData.primaryInfoBlocks}
			/>
		</section>
	);
};
